export default "\n<div (click)=\"onClick($event)\" class=\"c-button\"><i class=\"fas fa-trash\"></i></div>";